import { useEffect, useState, useCallback } from 'react';

import { makeGetCustomerField, makeGetCustomerFieldOrderByCategory } from './selector/index';

import { getAttrConfig } from './api';

const getCustomerField = makeGetCustomerField();
const getCustomerFieldByCategory = makeGetCustomerFieldOrderByCategory();

function useAttrConfig() {
  const [attrConfig, setAttrConfig] = useState([]);

  const handleGetAttrConfig = useCallback(() => {
    getAttrConfig().then(res => {
      if (res.data) {
        const attrConfig = res.data ? res.data.attr_config_list || [] : [];

        setAttrConfig(attrConfig);
      }
    });
  }, []);

  useEffect(() => {
    handleGetAttrConfig();
  }, []);

  return {
    attrConfig,
    getCustomerField,
    getCustomerFieldByCategory
  };
}

export default useAttrConfig;
